.DragHandle,
.InsertHandle {
  position: absolute;
  width: 20px;
  transform: translate(-22px, 4px);
  z-index: 1;
  &.dragSource {
    pointer-events: none;
    > * {
      animation: none;
    }
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.fadeOutHandle {
  position: absolute;
  pointer-events: none;
  transform: translate(-22px, calc(var(--offsetY, 0px) + 4px));
  width: 16px;
  height: 24px;
  display: flex;
  border-radius: 4px;
  animation: fade-out 400ms forwards;
  svg {
    color: var(--neutral-30);
  }
  &.insertHandle {
    transform: translate(-22px, calc(var(--offsetY, 0px) + 4px));
    display: flex;
    align-items: center;
    svg {
      color: var(--neutral-40);
      width: 16px;
      height: 14px;
    }
  }
}
